"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailTriggerDynamoMapper = void 0;
const dynamodb_mapper_1 = require("../dynamodb-mapper");
const email_trigger_json_1 = require("./email-trigger-json");
exports.EmailTriggerDynamoMapper = (0, dynamodb_mapper_1.createDynamoMapper)('EmailTrigger', email_trigger_json_1.EmailTriggerJsonMapper);
